import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LeagueListItem from '../components/LeagueListItem';
import { listLeagues } from '../services/api';

/**
 * League hub: lists the user's saved leagues and offers an Add League button.
 */
function LeagueHubView() {
  const { isLoggedIn, isLoading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [leagues, setLeagues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (authLoading) return;
    if (!isLoggedIn) {
      setLoading(false);
      return;
    }
    listLeagues()
      .then(data => setLeagues(data))
      .catch(err => setError(err.response?.data?.error?.message || 'Failed to load leagues'))
      .finally(() => setLoading(false));
  }, [authLoading, isLoggedIn]);

  function handleDeleteLeague(leagueId) {
    setLeagues(prev => prev.filter(l => l.leagueId !== leagueId));
  }

  if (authLoading || loading) {
    return (
      <div className='loading'>
        <div className='spinner' />
        <p>Loading leagues...</p>
      </div>
    );
  }

  if (!isLoggedIn) {
    return (
      <div className='card' style={{ maxWidth: 480, margin: '48px auto', textAlign: 'center' }}>
        <h2>My Leagues</h2>
        <p style={{ color: 'var(--text-muted)', marginBottom: 24 }}>
          Create a free account to track your in-season roster and get personalized advice.
        </p>
        <button
          className='btn btn-primary'
          onClick={() => navigate('/login?returnTo=/league')}
        >
          Sign in to get started
        </button>
      </div>
    );
  }

  return (
    <div className='card' style={{ maxWidth: 720, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>My Leagues</h2>
        <button className='btn btn-primary' onClick={() => navigate('/league/new')}>
          + Add League
        </button>
      </div>

      {error && <div className='error-banner'>{error}</div>}

      {leagues.map(l => (
        <LeagueListItem key={l.leagueId} league={l} onDelete={handleDeleteLeague} />
      ))}

      {leagues.length === 0 && (
        <div className='empty-state'>
          <h3>No leagues yet</h3>
          <p>Add a league to track your roster and get in-season advice.</p>
        </div>
      )}
    </div>
  );
}

export default LeagueHubView;
